import type { BaseConfig } from './typing';

export const statements: BaseConfig = {
    enabled: false,
    createStatement: false,
    deliveryDefinitions: {
        distribution: [],
        format: [],
        periodicity: [],
        canCreateDefinition: false,
        channelEditable: false,
        statementNumberEditable: false,
    },
    showHelpCenterInfoBox: false,
    showMultiDownloadCard: false,
    showNewCustomStatementCard: false,
    showDownloadOptions: false,
    hasAsyncBankSigningFeature: false,
    tableColumns: [
        { id: 'name', label: 'main.settings.name', width: '40%' },
        { id: 'time-span', label: 'account.statements.timeFrame', width: '30%' },
        { id: 'format', label: 'account.statements.statementFormat', width: '20%' },
        { id: 'download', label: 'app.download', width: '10%' },
    ],
    tableColumnsWithBankSignature: [
        { id: 'name', label: 'main.settings.name', width: '30%' },
        { id: 'time-span', label: 'account.statements.timeFrame', width: '30%' },
        { id: 'format', label: 'account.statements.statementFormat', width: '10%' },
        {
            id: 'bank-signature',
            label: 'account.statements.bankSignature',
            width: '20%',
            className: 'text-right',
        },
        { id: 'download', label: 'app.download', width: '10%' },
    ],
};
